module.exports = __webpack_public_path__ + "e7a7d30995cebdeacaf90009e67d1c1b.MP3";